import Home from "../pages/Home";
import Login from "../pages/Login";
import Customers from "../pages/Customers";
import CustomerNew from "../pages/CustomerNew";
import CustomerDetails from "../pages/CustomerDetail";
import CustomerUpdate from "../pages/CustomerUpdate";
import Products from "../pages/Products";
import ProductNew from "../pages/ProductNew";
import ProductDetails from "../pages/ProductDetails";
import ProductUpdate from "../pages/ProductUpdate";
import Orders from "../pages/Orders";
import Quotes from "../pages/Quotes";
import PriceManagement from "../pages/PriceManagement";
import Profile from "../pages/Profile";
import Categories from "../pages/Categories";
import CategoryNew from "../pages/CategoryNew";
import AdminUsers from "../pages/AdminUsers";
import AdminUserNew from "../pages/AdminUserNew";
import AdminUserUpdate from "../pages/AdminUserUpdate";
import CategoryDetails from "../pages/CategoryDetails";
import CategoryUpdate from "../pages/CategoryUpdate";
import Formats from "../pages/Formats";
import FormatNew from "../pages/FormatNew";
import FormatDetails from "../pages/FormatDetails";
import FormatUpdate from "../pages/FormatUpdate";
import Comforts from "../pages/Comforts";
import ComfortNew from "../pages/ComfortNew";
import ComfortDetails from "../pages/ComfortDetails";
import ComfortUpdate from "../pages/ComfortUpdate";
import Platings from "../pages/Platings";
import PlatingNew from "../pages/PlatingNew";
import PlatingDetails from "../pages/PlatingDetails";
import PlatingUpdate from "../pages/PlatingUpdate";
import ExternalFinishings from "../pages/ExternalFinishings";
import ExternalFinishingNew from "../pages/NewExternalFinishing";
import ExternalFinishingDetails from "../pages/ExternalFinishingDetails";
import ExternalFinishingUpdate from "../pages/ExternalFinishingUpdate";
import AdminUserDetails from "../pages/AdminUserDetails";
import OrderNew from "../pages/OrderNew";
import OrderPaymentMethods from "../pages/OrderPaymentMethods";
import OrderPaymentMethodsNew from "../pages/OrderPaymentMethodsNew";
import OrderPaymentMethodDetails from "../pages/OrderPaymentMethodDetails";
import OrderPaymentMethodUpdate from "../pages/OrderPaymentMethodUpdate";
import PriceGroups from "../pages/PriceGroups";
import PriceGroupNew from "../pages/PriceGroupNew";
import PriceGroupDetails from "../pages/PriceGroupDetails";
import PriceGroupUpdate from "../pages/PriceGroupUpdate";
import Stones from "../pages/Stones";
import StoneNew from "../pages/StoneNew";
import StoneDetails from "../pages/StoneDetails";
import StoneUpdate from "../pages/StoneUpdate";
import StoneVariations from "../pages/StoneVariations";
import StoneVariationNew from "../pages/StoneVariationNew";
import StoneVariationDetails from "../pages/StoneVariationDetails";
import StoneVariationUpdate from "../pages/StoneVariationUpdate";
import AdminUserPermissions from "../pages/AdminUserPermissions";
import ClaspTypes from "../pages/ClaspTypes";
import ClaspTypeNew from "../pages/ClaspTypeNew";
import ClaspTypeDetails from "../pages/ClaspTypeDetails";
import ClaspTypeUpdate from "../pages/ClaspTypeUpdate";
import OrderDetails from "../pages/OrderDetails";
import Services from "../pages/Services";
import ServiceNew from "../pages/ServiceNew";
import ServiceDetails from "../pages/ServiceDetails";
import ServiceUpdate from "../pages/ServiceUpdate";
import Production from "../pages/Production";
import ProductionSteps from "../pages/ProductionSteps";
import ProductionStepNew from "../pages/ProductionStepNew";
import ProductionStepUpdate from "../pages/ProductionStepUpdate";
import ProductionStepDetails from "../pages/ProductionStepDetails";
import ProductionDetails from "../pages/ProductionDetails";
import QuoteDetails from "../pages/QuoteDetails";
import QuoteAnswer from "../pages/QuoteAnswer";
import OrderVerification from "../pages/OrderVerification";
import ProductionClosing from "../pages/ProductionClosing";
import ResetPassword from "../pages/ResetPassword";
import ProductionScreening from "../pages/ProductionScreening";
import ResetPasswordPublic from "../pages/ResetPasswordPublic";
import Financial from "../pages/Financial";
import ActivityLog from "../pages/ActivityLog";
import CustomersLog from "../pages/CustomersLog";
import SettingsHouse from "../pages/SettingsHouse";
import Metals from "../pages/Metals";
import MetalNew from "../pages/MetalNew";
import MetalUpdate from "../pages/MetalUpdate";
import MetalDetails from "../pages/MetalDetails";
import ProductionPresets from "../pages/ProductionPresets";
import ProductionPresetNew from "../pages/ProductionPresetNew";
import ProductionPresetUpdate from "../pages/ProductionPresetUpdate";
import ProductionPresetDetails from "../pages/ProductionPresetDetails";

export const routes = [
  { path: "/", loggedComponent: Home, private: true },
  { path: "/dashboard", loggedComponent: Home, private: true },
  { path: "/login", loggedComponent: Home, defaultComponent: Login },
  { path: "/redefinir-senha", loggedComponent: ResetPassword, private: true },
  { path: "/redefinicao-de-senha", defaultComponent: ResetPasswordPublic, },
  { path: "/perfil", loggedComponent: Profile, private: true },
  { path: "/usuarios", loggedComponent: AdminUsers, private: true },
  { path: "/usuario-cadastrar", loggedComponent: AdminUserNew, private: true },
  { path: "/usuario-editar/:id", loggedComponent: AdminUserUpdate, private: true },
  { path: "/usuario-detalhes/:id", loggedComponent: AdminUserDetails, private: true },
  { path: "/usuario-permissoes/:id", loggedComponent: AdminUserPermissions, private: true },
  { path: "/clientes", loggedComponent: Customers, private: true },
  { path: "/cliente-cadastrar", loggedComponent: CustomerNew, private: true },
  { path: "/cliente-detalhes/:id", loggedComponent: CustomerDetails, private: true },
  { path: "/cliente-editar/:id", loggedComponent: CustomerUpdate, private: true },
  { path: "/produtos", loggedComponent: Products, private: true },
  { path: "/produto-cadastrar", loggedComponent: ProductNew, private: true },
  { path: "/produto-detalhes/:id", loggedComponent: ProductDetails, private: true },
  { path: "/configuracao-casa", loggedComponent: SettingsHouse, private: true },
  { path: "/configuracao-metais", loggedComponent: Metals, private: true },
  { path: "/configuracao-metal-cadastrar", loggedComponent: MetalNew, private: true },
  { path: "/configuracao-metal-editar/:id", loggedComponent: MetalUpdate, private: true },
  { path: "/configuracao-metal-detalhes/:id", loggedComponent: MetalDetails, private: true },
  { path: "/configuracao-presets", loggedComponent: ProductionPresets, private: true },
  { path: "/configuracao-preset-cadastrar", loggedComponent: ProductionPresetNew, private: true },
  { path: "/configuracao-preset-editar/:id", loggedComponent: ProductionPresetUpdate, private: true },
  { path: "/configuracao-preset-detalhes/:id", loggedComponent: ProductionPresetDetails, private: true },
  { path: "/configuracao-etapas", loggedComponent: ProductionSteps, private: true },
  { path: "/configuracao-etapa-cadastrar", loggedComponent: ProductionStepNew, private: true },
  { path: "/configuracao-etapa-editar/:id", loggedComponent: ProductionStepUpdate, private: true },
  { path: "/configuracao-etapa-detalhes/:id", loggedComponent: ProductionStepDetails, private: true },
  { path: "/producao-etapas", loggedComponent: ProductionSteps, private: true },
  { path: "/producao-etapa-cadastrar", loggedComponent: ProductionStepNew, private: true },
  { path: "/producao-etapa-editar/:id", loggedComponent: ProductionStepUpdate, private: true },
  { path: "/producao-etapa-detalhes/:id", loggedComponent: ProductionStepDetails, private: true },
  { path: "/producao/:step?", loggedComponent: Production, private: true },
  { path: "/producao-detalhes/:id", loggedComponent: ProductionDetails, private: true },
  { path: "/producao-triagem/:id", loggedComponent: ProductionScreening, private: true },
  { path: "/producao-fechamento/:id", loggedComponent: ProductionClosing, private: true },
  { path: "/produto-editar/:id", loggedComponent: ProductUpdate, private: true },
  { path: "/servicos", loggedComponent: Services, private: true },
  { path: "/servico-cadastrar", loggedComponent: ServiceNew, private: true },
  { path: "/servico-detalhes/:id", loggedComponent: ServiceDetails, private: true },
  { path: "/servico-editar/:id", loggedComponent: ServiceUpdate, private: true },
  { path: "/categorias", loggedComponent: Categories, private: true },
  { path: "/categoria-cadastrar", loggedComponent: CategoryNew, private: true },
  { path: "/categoria-detalhes/:id", loggedComponent: CategoryDetails, private: true },
  { path: "/categoria-editar/:id", loggedComponent: CategoryUpdate, private: true },
  { path: "/formatos", loggedComponent: Formats, private: true },
  { path: "/formato-cadastrar", loggedComponent: FormatNew, private: true },
  { path: "/formato-detalhes/:id", loggedComponent: FormatDetails, private: true },
  { path: "/formato-editar/:id", loggedComponent: FormatUpdate, private: true },
  { path: "/confortos", loggedComponent: Comforts, private: true },
  { path: "/conforto-cadastrar", loggedComponent: ComfortNew, private: true },
  { path: "/conforto-detalhes/:id", loggedComponent: ComfortDetails, private: true },
  { path: "/conforto-editar/:id", loggedComponent: ComfortUpdate, private: true },
  { path: "/banhos", loggedComponent: Platings, private: true },
  { path: "/banho-cadastrar", loggedComponent: PlatingNew, private: true },
  { path: "/banho-detalhes/:id", loggedComponent: PlatingDetails, private: true },
  { path: "/banho-editar/:id", loggedComponent: PlatingUpdate, private: true },
  { path: "/acabamentos-externos", loggedComponent: ExternalFinishings, private: true },
  { path: "/acabamento-externo-cadastrar", loggedComponent: ExternalFinishingNew, private: true },
  { path: "/acabamento-externo-detalhes/:id", loggedComponent: ExternalFinishingDetails, private: true },
  { path: "/acabamento-externo-editar/:id", loggedComponent: ExternalFinishingUpdate, private: true },
  { path: "/fechos", loggedComponent: ClaspTypes, private: true },
  { path: "/fecho-cadastrar", loggedComponent: ClaspTypeNew, private: true },
  { path: "/fecho-detalhes/:id", loggedComponent: ClaspTypeDetails, private: true },
  { path: "/fecho-editar/:id", loggedComponent: ClaspTypeUpdate, private: true },
  { path: "/pedidos", loggedComponent: Orders, private: true },
  { path: "/pedido-novo", loggedComponent: OrderNew, private: true },
  { path: "/pedido-detalhes/:id", loggedComponent: OrderDetails, private: true },
  { path: "/pedido-verificacao/:id", loggedComponent: OrderVerification, private: true },
  { path: "/formas-de-pagamento", loggedComponent: OrderPaymentMethods, private: true },
  { path: "/forma-de-pagamento-cadastro", loggedComponent: OrderPaymentMethodsNew, private: true },
  { path: "/forma-de-pagamento-detalhes/:id", loggedComponent: OrderPaymentMethodDetails, private: true },
  { path: "/forma-de-pagamento-editar/:id", loggedComponent: OrderPaymentMethodUpdate, private: true },
  { path: "/pedras", loggedComponent: Stones, private: true },
  { path: "/pedra-cadastrar", loggedComponent: StoneNew, private: true },
  { path: "/pedra-detalhes/:id", loggedComponent: StoneDetails, private: true },
  { path: "/pedra-editar/:id", loggedComponent: StoneUpdate, private: true },
  { path: "/pedra-variacoes/:id", loggedComponent: StoneVariations, private: true },
  { path: "/pedra-variacao-cadastrar/:id", loggedComponent: StoneVariationNew, private: true },
  { path: "/pedra-variacao-detalhes/:id", loggedComponent: StoneVariationDetails, private: true },
  { path: "/pedra-variacao-editar/:id", loggedComponent: StoneVariationUpdate, private: true },
  { path: "/grupos-de-indices", loggedComponent: PriceGroups, private: true },
  { path: "/grupo-de-indice-cadastro", loggedComponent: PriceGroupNew, private: true },
  { path: "/grupo-de-indice-detalhes/:id", loggedComponent: PriceGroupDetails, private: true },
  { path: "/grupo-de-indice-editar/:id", loggedComponent: PriceGroupUpdate, private: true },

  { path: "/orcamentos", loggedComponent: Quotes, private: true },
  { path: "/orcamento-detalhes/:id", loggedComponent: QuoteDetails, private: true },
  { path: "/orcamento-responder/:id", loggedComponent: QuoteAnswer, private: true },

  { path: "/financeiro", loggedComponent: Financial, private: true },
  { path: "/cotacao", loggedComponent: PriceManagement, private: true },
  { path: "/log", loggedComponent: ActivityLog, private: true },
  { path: "/log-clientes", loggedComponent: CustomersLog, private: true },
  { path: "*", loggedComponent: Home, private: true }
];

export default routes;